export default "__VITE_PUBLIC_ASSET__4a5b8cbe__"